import { render, staticRenderFns } from "./tfDimensional.vue?vue&type=template&id=4c1342b0&scoped=true"
import script from "./tfDimensional.vue?vue&type=script&lang=js"
export * from "./tfDimensional.vue?vue&type=script&lang=js"
import style0 from "./tfDimensional.vue?vue&type=style&index=0&id=4c1342b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1342b0",
  null
  
)

export default component.exports